import { ComponentProps } from "react";
import { Link } from "react-router-dom";
import { classnames } from "../../utils";
import styles from "./Button.module.scss";

export type ButtonVariant = "primary" | "secondary" | "tertiary" | "text";

type ButtonProps = ComponentProps<"button"> & {
  children: React.ReactNode | string;
  variant?: ButtonVariant;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  fullWidth?: boolean;
  as?: "button" | "a";
  to?: string;
  target?: string;
};

export default function Button({
  variant = "primary",
  children,
  fullWidth,
  className = "",
  iconLeft,
  iconRight,
  as = "button",
  to,
  ...delegated
}: ButtonProps) {
  const Tag = as === "button" ? "button" : LinkWrapper;
  const appliedClasses = classnames([
    styles.wrapper,
    styles[variant],
    fullWidth ? styles.fullWidth : styles.inline,
    iconRight || iconLeft ? styles.spaceBetween : "",
    className,
  ]);

  return (
    <Tag className={appliedClasses} to={to} {...delegated}>
      <span>
        {iconLeft && <span className={styles.iconLeft}>{iconLeft}</span>}
        {children}
      </span>
      {iconRight && <span className={styles.iconRight}>{iconRight}</span>}
    </Tag>
  );
}

const LinkWrapper = ({
  to,
  children,
  ...delegated
}: React.PropsWithChildren<{ to?: string }>) => {
  return (
    <Link to={to || "/"} {...delegated}>
      {children}
    </Link>
  );
};
